import { ClearIcon as MuiClearIcon } from '@mui/x-date-pickers';

const ClearIcon = MuiClearIcon;

export default ClearIcon;
